import { findIndex } from 'lodash';
import {
  getCompanyDataAction,
  getCompanySeasonsValueAction,
  getCompanyVenuesAction,
  getCompanyUnpublishedSeasonAction,
  getCompanyContactAction,
  updateCompanyAction,
  getMusicalWorksListAction,
  getCompanyEditSeasonAction,
  getCompanyImagesAction,
  getCompanyVideosAction,
  getCompanyStaffAction,
  getCompanyDescriptionsAction,
  createCompanyDescriptionAction,
  updateCompanyDescriptionAction,
  deleteCompanyDescriptionAction,
} from './actions';
import {
  listReducer,
  defaultListParams,
  entityReducer,
  defaultEntityParams,
  namedListParams,
} from '../../utils/crudUtils';
import { CLEAR_EDIT_SEASONS, SET_COMPANY, SET_SEASONS } from './constants';

export const key = 'Company';

export const initialState = {
  companyData: defaultEntityParams,
  editSeasonProductions: defaultListParams,
  unpublishedProductions: defaultListParams,
  venues: namedListParams('venues'),
  seasons: defaultListParams,
  error: null,
  musicalWorksList: defaultListParams,
  images: namedListParams('images'),
  videos: namedListParams('videos'),
  staff: namedListParams('staff'),
  isStaffUpdating: false,
  staffSuggestions: namedListParams('staffSuggestions'),
  descriptions: namedListParams('descriptions'),
};

const companyReducer = (state = initialState, { type, payload }) => {
  switch (type) {
    case getCompanyDataAction.TRIGGER:
      return { ...state, error: null };
    case getCompanyDataAction.SUCCESS:
      return { ...state, companyData: payload };
    case getCompanyDataAction.FAILURE:
      return { ...state, error: payload };

    case getCompanyContactAction.TRIGGER:
    case getCompanyContactAction.SUCCESS:
    case getCompanyContactAction.FAILURE:
      return listReducer(
        state,
        type,
        payload.data ? { ...payload, data: payload.data.map(el => ({ ...el, name: el.name.toLowerCase() })) } : payload,
        'contacts',
      );

    case getCompanyEditSeasonAction.TRIGGER:
    case getCompanyEditSeasonAction.SUCCESS:
    case getCompanyEditSeasonAction.FAILURE:
      return listReducer(state, type, payload, 'editSeasonProductions');

    case getCompanyUnpublishedSeasonAction.TRIGGER:
    case getCompanyUnpublishedSeasonAction.SUCCESS:
    case getCompanyUnpublishedSeasonAction.FAILURE:
      return listReducer(state, type, payload, 'unpublishedProductions');

    case getCompanySeasonsValueAction.TRIGGER:
    case getCompanySeasonsValueAction.SUCCESS:
    case getCompanySeasonsValueAction.FAILURE:
      return listReducer(state, type, payload, 'seasons');

    case SET_SEASONS:
      return { ...state, seasons: payload.seasons };

    case getCompanyVenuesAction.TRIGGER:
    case getCompanyVenuesAction.SUCCESS:
    case getCompanyVenuesAction.FAILURE:
      return listReducer(state, type, payload, initialState.venues.listName);

    case updateCompanyAction.TRIGGER:
    case updateCompanyAction.SUCCESS:
    case updateCompanyAction.FAILURE:
      return entityReducer(state, type, payload, 'companyData');

    case SET_COMPANY:
      return { ...state, companyData: { ...state.companyData, entity: payload } };

    case CLEAR_EDIT_SEASONS:
      return { ...state, editSeasonProductions: { ...state.editSeasonProductions, data: [] } };

    case getMusicalWorksListAction.TRIGGER:
    case getMusicalWorksListAction.SUCCESS:
    case getMusicalWorksListAction.FAILURE:
      return listReducer(state, type, payload, 'musicalWorksList');

    case getCompanyImagesAction.FAILURE:
    case getCompanyImagesAction.TRIGGER:
    case getCompanyImagesAction.SUCCESS:
      return listReducer(state, type, payload, initialState.images.listName);

    case getCompanyVideosAction.FAILURE:
    case getCompanyVideosAction.TRIGGER:
    case getCompanyVideosAction.SUCCESS:
      return listReducer(state, type, payload, initialState.videos.listName);

    case getCompanyStaffAction.FAILURE:
    case getCompanyStaffAction.TRIGGER:
    case getCompanyStaffAction.SUCCESS:
      return listReducer(state, type, payload, initialState.staff.listName);

    case getCompanyDescriptionsAction.TRIGGER:
    case getCompanyDescriptionsAction.SUCCESS:
    case getCompanyDescriptionsAction.FAILURE:
      return listReducer(state, type, payload, 'descriptions');

    case createCompanyDescriptionAction.SUCCESS:
      return { ...state, descriptions: { ...state.descriptions, data: [...state.descriptions.data, payload.entity] } };

    case updateCompanyDescriptionAction.SUCCESS: {
      const descriptions = [...state?.descriptions?.data];
      const updatedDescriptionIndex = findIndex(state?.descriptions?.data, { id: payload?.entity?.id });
      descriptions.splice(updatedDescriptionIndex, 1, payload?.entity);
      return { ...state, descriptions: { ...state.descriptions, data: descriptions } };
    }

    case deleteCompanyDescriptionAction.TRIGGER:
      return { ...state, descriptions: { ...state.descriptions, loading: true } };
    case deleteCompanyDescriptionAction.SUCCESS: {
      return {
        ...state,
        descriptions: {
          ...state.descriptions,
          data: state.descriptions.data.filter(d => d?.id !== payload?.id),
          loading: false,
        },
      };
    }
    case deleteCompanyDescriptionAction.FAILURE:
      return { ...state, descriptions: { ...state.descriptions, loading: false } };

    default:
      return state;
  }
};

export default companyReducer;
